import {AxiosResponse} from 'axios'
import Api from '../api'

export default (listingId: number, extraHeaders?: Record<string, string>): Promise<AxiosResponse> => {
    if (listingId === undefined) {
        console.warn('Listing ID is undefined');
        return 
      }
  const path = `/listings/listing-view/light/${listingId}/v2`
  return Api.getInstance(false, false, process.env.REACT_APP_API_SUB_URL, true, false, extraHeaders).request.get(
    `${path}`,
    path
  )
}
